export function readFile(file, type = 'readAsText') {
  const reader = new FileReader();
  reader[type](file);
  return new Promise((resolve) => {
    reader.addEventListener('load', _ => resolve(_.target.result));
  });
};

export const getLiffIdFromUrl = _ => (_.match(/^line:\/\/app\/(.+)$/) || _.match(/liff\.line\.me\/(.+)$/) || [])[1];
